export default __webpack_public_path__ + "static/11-65e9c29f0d0d0623337c9a401f71fc38.png";